import React from 'react';
import{ ALLOWED_CONTENT_TYPES, MAX_PARALLEL_FILES_UPLOADS } from '@evo/chat-core';

import { Icon } from '../../../../../ui/icon';
import PictureIconSvg from './images/picture.icon.svg';

import * as a from '../../../../../../libs/actions';

import css from './fileInput.sss';


export class FileInput extends React.Component {

    handleSelectFiles = (e) => {
        const files = Array.from(e.target.files);
        e.target.value = null;
        this.props.send(a.EVENT_DIALOG_SEND_FILES, {
            files: files.slice(0, MAX_PARALLEL_FILES_UPLOADS)
        });
    }

    render() {
        return (
            <span className={css.root}>
                <Icon
                    className={css.icon}
                    glyph={PictureIconSvg}
                />
                <input
                    className={css.iuput}
                    type='file'
                    multiple='multiple'
                    accept={ALLOWED_CONTENT_TYPES.join(', ')}
                    onChange={this.handleSelectFiles}
                />
            </span>
        )
    }
}
